<template>
    <a-button type="ghost" shape="round" @click="visible = !visible">
        <template #icon>
            <!-- <DownloadOutlined /> -->
        </template>
        {{ bindCode.mode == 'json' ? '编写对象' : '编写代码' }}
    </a-button>

    <a-modal :title="bindCode.mode == 'json' ? '编写对象' : '编写代码'" width="550" :visible="visible" @cancel="handleCancel">
        <div>{{ bindCode.mode == 'json' ? bindCode.title : bindCode.title + '(){' }}</div>
        <ace-editor v-model="bindCode.code" v-if="visible" style="height: 350px;" :mode="bindCode.mode"></ace-editor>
        <div>{{ bindCode.mode == 'json' ? '' : '}' }}</div>
        <template #footer>
            <a-button @click="handleCancel">取消</a-button>
            <a-button @click="handleOk" type="primary">确定</a-button>
        </template>
    </a-modal>
</template>

<script setup>
import AceEditor from "../ace-editor/ace-editor.vue"
import { ref, toRefs } from "vue";
const props = defineProps({
    bindCode: Object,
})
const emits = defineEmits(["handleOk"]);
const { bindCode } = toRefs(props)
const visible = ref(false)

const handleCancel = () => {
    visible.value = false
}
const handleOk = () => {
    emits('handleOk', bindCode.value)
    visible.value = false
}
</script>